export default {
    news: [],
};



// WEBPACK FOOTER //
// ./src/store/modules/news/state.js